var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuPadel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 2) scale(0.706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5481 27.5649L33.2096 25.6029C33.2096 25.6029 28.3993 22.4083 25.8956 20.1861C23.392 17.9639 21.1595 13.1848 20.4936 11.9541C19.8274 10.7235 19.3103 3.57245 11.6438 1.02795C9.90193 0.597548 7.50368 0.257763 3.53791 4.9569C-0.427853 9.65605 0.972182 14.2295 4.17085 16.4189C7.36951 18.6082 10.4526 19.2431 13.8587 19.3914C17.2648 19.5397 22.5413 20.7931 24.1142 21.5622C25.2711 22.1283 31.5481 27.5649 31.5481 27.5649ZM18.3464 15.5919C18.3464 15.5919 14.1476 21.6631 5.15697 15.8479C1.67238 13.594 1.87849 11.2034 1.79057 10.3775C1.70266 9.55162 4.70468 3.35661 7.85801 2.41285C11.0113 1.46908 10.681 0.7666 14.9455 4.01255C14.9455 4.01255 21.4827 9.73281 18.3464 15.5919ZM17.5976 18.9501C17.299 18.8583 16.0733 18.8941 17.6079 17.6922C19.4026 16.2866 19.5264 15.1467 19.7506 14.4619C19.8395 14.1897 19.9423 14.0181 20.0337 13.9104C20.1585 13.7629 20.3813 13.7532 20.5197 13.888C21.5072 14.8498 24.4626 19.6491 24.0613 20.2169C23.6173 20.8452 18.0503 19.0892 17.5976 18.9501Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7001 3.60758C18.7097 6.99147 21.738 11.5484 18.5322 15.347C15.3264 19.1457 8.77255 19.5415 4.76291 16.1576C0.753265 12.7737 0.9851 9.00528 4.19089 5.20667C7.39668 1.40806 10.6904 0.223698 14.7001 3.60758Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.63978,
    cy: 8.98491,
    r: 0.913043,
    transform: "rotate(-51.7247 3.63978 8.98491)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5265,
    cy: 6.59562,
    r: 0.913043,
    transform: "rotate(-51.7247 5.5265 6.59562)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.41126,
    cy: 4.20634,
    r: 0.913043,
    transform: "rotate(-51.7247 7.41126 4.20634)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.08704,
    cy: 12.0649,
    r: 0.913043,
    transform: "rotate(-51.7247 5.08704 12.0649)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.97181,
    cy: 9.67558,
    r: 0.913043,
    transform: "rotate(-51.7247 6.97181 9.67558)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.85657,
    cy: 7.2863,
    r: 0.913043,
    transform: "rotate(-51.7247 8.85657 7.2863)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7413,
    cy: 4.89702,
    r: 0.913043,
    transform: "rotate(-51.7247 10.7413 4.89702)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.53431,
    cy: 15.1447,
    r: 0.913043,
    transform: "rotate(-51.7247 6.53431 15.1447)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.41907,
    cy: 12.7554,
    r: 0.913043,
    transform: "rotate(-51.7247 8.41907 12.7554)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.3058,
    cy: 10.3663,
    r: 0.913043,
    transform: "rotate(-51.7247 10.3058 10.3663)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.1906,
    cy: 7.97697,
    r: 0.913043,
    transform: "rotate(-51.7247 12.1906 7.97697)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.0753,
    cy: 5.58769,
    r: 0.913043,
    transform: "rotate(-51.7247 14.0753 5.58769)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.86634,
    cy: 15.8352,
    r: 0.913043,
    transform: "rotate(-51.7247 9.86634 15.8352)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7511,
    cy: 13.446,
    r: 0.913043,
    transform: "rotate(-51.7247 11.7511 13.446)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6359,
    cy: 11.0568,
    r: 0.913043,
    transform: "rotate(-51.7247 13.6359 11.0568)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5206,
    cy: 8.66752,
    r: 0.913043,
    transform: "rotate(-51.7247 15.5206 8.66752)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.1964,
    cy: 16.5259,
    r: 0.913043,
    transform: "rotate(-51.7247 13.1964 16.5259)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.0812,
    cy: 14.1366,
    r: 0.913043,
    transform: "rotate(-51.7247 15.0812 14.1366)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.9679,
    cy: 11.7474,
    r: 0.913043,
    transform: "rotate(-51.7247 16.9679 11.7474)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75395 14.2254C2.34966 15.8897 2.56066 18.377 4.22488 19.7815C5.88911 21.1857 8.37584 20.9753 9.78039 19.3113C11.1849 17.6471 10.9749 15.1597 9.31083 13.7551C7.64649 12.3505 5.15855 12.5611 3.75395 14.2254Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPadel);
export default __webpack_public_path__ + "static/media/menuPadel.8f80bae1565fe4f8bde0314bfdc1a07d.svg";
export { ForwardRef as ReactComponent };